/* eslint-disable react/jsx-no-useless-fragment */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { IBuiltWith, IPostDetailResponse } from '@/redux/post/post.d';

function OnefinityDetailsCard({ post }: { post: IPostDetailResponse }) {
  const { onefinityController, onefinityModel, onefinitySize, builtWith } =
    post;

  if (!onefinityController && !onefinityModel && !onefinitySize) {
    return <></>;
  }

  if (builtWith !== IBuiltWith.ONEFINITY) {
    return <></>;
  }

  return onefinityController || onefinityModel || onefinitySize ? (
    <Card className="my-5">
      <CardHeader>
        <CardTitle>CNC Machine Details</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-2 text-sm">
          {builtWith === IBuiltWith.ONEFINITY ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Brand:</dt>
              <dd>Onefinity</dd>
            </div>
          ) : (
            <></>
          )}
          {onefinityModel ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Model:</dt>
              <dd>{onefinityModel}</dd>
            </div>
          ) : (
            <></>
          )}
          {onefinityController ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Controller:</dt>
              <dd>{onefinityController}</dd>
            </div>
          ) : (
            <></>
          )}
          {onefinitySize ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Size:</dt>
              <dd>{onefinitySize}</dd>
            </div>
          ) : (
            <></>
          )}
        </dl>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
}

export default OnefinityDetailsCard;
